import { render, staticRenderFns } from "./highLowestList.vue?vue&type=template&id=61caf20a"
import script from "./highLowestList.vue?vue&type=script&lang=js"
export * from "./highLowestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports